/** @jsxImportSource @emotion/react */

import { Stack } from "@mui/material";

function MailIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <Stack css={{ display: "flex", alignItems: "center" }}>
      <svg
        width={17}
        height={17}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <mask
          id="prefix__mail"
          style={{
            maskType: "alpha",
          }}
          maskUnits="userSpaceOnUse"
          x={1}
          y={1}
          width={15}
          height={14}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.606 13.931H5.049c-.76 0-1.434-.272-1.952-.789-.6-.598-.93-1.457-.93-2.419V6.144c0-1.862 1.217-3.213 2.894-3.213h6.545c1.677 0 2.894 1.351 2.894 3.213v4.579c0 .962-.33 1.821-.93 2.42-.518.516-1.193.788-1.953.788h-.011zm-9.215-.08c.71.707 1.628 1.08 2.657 1.08h6.568c1.031 0 1.95-.374 2.66-1.08.79-.788 1.224-1.899 1.224-3.128V6.144c0-2.402-1.674-4.213-3.894-4.213H5.06c-2.22 0-3.894 1.811-3.894 4.213v4.579c0 1.23.434 2.34 1.224 3.128zM7.09 9.132a2.028 2.028 0 002.532-.004l2.963-2.408a.5.5 0 00-.631-.776L8.995 8.348c-.378.3-.906.3-1.282.003L4.726 5.943a.5.5 0 00-.627.779l2.99 2.41z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#prefix__mail)">
          <path fill="#fff" fillOpacity={0.6} d="M.767.557h16v16h-16z" />
        </g>
      </svg>
    </Stack>
  );
}

export default MailIcon;
